



























require("@/assets/css/admin-card.scss");
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class CategoryListCard extends Vue{
    @Prop() categoryColor!:string;
}
